<template>
  <div class="overlay">
    <div class="callout secondary text-center padding-2">
      <h5>{{ $t('title') }}</h5>
      <p v-html="$t('description')" />
    </div>
  </div>
</template>

<script>
import { components } from 'locales';

export default {
  name: 'AssemblyUnavailableOverlay',
  i18n: components.boards.AssemblyUnavailableOverlay,
};
</script>

<style scoped lang="scss">
.overlay {
  position: absolute;
  height: 100%;
  background-color: #ffffff99;
  z-index: 100;

  display: flex;
  padding: 5rem;
  flex-direction: column;
  justify-content: center;
}
</style>
